import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  AggregationInterval, ArgumentAxis, Aggregation,
  TickInterval, CommonSeriesSettings, } from 'devextreme-react/chart';
import { groupBy } from '../../utils/miscUtil';

export default function HSEHazardGraph(props) {

  const [data, setData] = useState();

  const [values, setValues] = useState([]);

  const calculateCount = useCallback((aggregationInfo) => {
    if (!aggregationInfo.data.length) {
      return null;
    }
    var total = 0;
    var fd = groupBy(aggregationInfo.data, 'value')
    for (const [key] of Object.entries(fd)) {
      total = total + fd[key].length
      fd[key] = fd[key].length
    }

    fd['total']=total;
    fd['date'] = aggregationInfo.intervalStart;
    return fd;
  }, []);

  const customizeTooltip = useCallback((pointInfo) => {
    let y = pointInfo.argument.getFullYear().toString();
    var txt = ''
    if (pointInfo.total !== undefined) {
      txt = `<div><div class="tooltip-header">${y} total: ${pointInfo.total}</div><div class="tooltip-body">`
      for (var i=0; i<pointInfo.points.length; i++) {
        txt = txt+`<div>${pointInfo.points[i].seriesName}: ${pointInfo.points[i].valueText} (${pointInfo.points[i].percentText})</div>`
      }
      txt=txt+`</div></div>`
    }
    return {
      html: txt,
    }
  }, []);

  useEffect(() => {
    if (!props.data) return;
    var fd = props.data.filter((it) => it['Identifier']===props.metricId && props.weight.includes(props.weightData[it["company_id"]]));
    var i = 0;
    var nrFound = false;
    for (i=0; i<fd.length; i++){
      fd[i]["date"] = new Date(fd[i]["year"], 0)
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
      if (fd[i]["value"] === "NR") {
        nrFound = true
      }
    }
    var fd1 = Object.keys(groupBy(fd,"value"));
    if (nrFound) {
      const index = fd1.indexOf("NR");
      fd1.splice(index, 1);
      fd1.push("NR")
    }
    setValues(fd1)
    setData(fd);

  }, [props.data, props.year, props.metricId, props.weight, props.weightData]);

  return (
      <Chart
        id="chart"
        width="100%"
        dataSource={data}
        title={props.title}
        rotated={true}
        barGroupWidth={20}
        height={"300px"}
      >
        <ArgumentAxis aggregatedPointsPosition="crossTicks">
          <AggregationInterval years={1} />
          <TickInterval years={1} />
        </ArgumentAxis>

        <CommonSeriesSettings
          argumentField="date"
        >
          <Aggregation
            enabled={true}
            calculate={calculateCount}
            method="custom"
          />
        </CommonSeriesSettings>
        {values.map((e) => (<Series
          type="stackedbar"
          key={"value_"+e}
          valueField={e}
          name={e}
          color={e==="NR"?"rgba(0, 0, 0, 0.1)":""}
          ignoreEmptyPoints={true}
        />))}

        <ValueAxis showZero={true} />
        <Legend
          visible={true}
          rowCount={2}
          verticalAlignment="bottom"
          horizontalAlignment="center"/>
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
  );
}
